import React from "react";
import {
  Box,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
} from "@mui/material";

const MentionList = React.memo(({ 
  members, 
  selectedIndex, 
  onSelect, 
  theme 
}) => {
  if (!members || members.length === 0) return null;

  return (
    <Paper
      sx={{
        position: "absolute",
        bottom: "100%",
        left: 0,
        width: "auto",
        minWidth: "280px",
        maxWidth: "320px",
        mb: 1,
        maxHeight: "250px",
        overflowY: "auto",
        zIndex: 99999,
        backgroundColor: "#FFFFFF",
        border: "2px solid #7C3AED",
        borderRadius: "12px",
        boxShadow: "0 10px 40px rgba(124, 58, 237, 0.25), 0 4px 16px rgba(0, 0, 0, 0.1)",
        animation: "slideUp 0.2s ease-in-out",
        "@keyframes slideUp": {
          "0%": {
            opacity: 0,
            transform: "translateY(10px)",
          },
          "100%": {
            opacity: 1,
            transform: "translateY(0)",
          },
        },
        [theme.breakpoints.down("md")]: {
          left: "50%",
          transform: "translateX(-50%)",
          width: "90vw",
          maxWidth: "320px",
          minWidth: "280px",
        },
      }}
    >
      <Box
        sx={{
          px: 1.5,
          py: 1,
          borderBottom: "1px solid #E5E7EB",
          backgroundColor: "#F9FAFB",
          display: "flex",
          alignItems: "center",
          gap: 0.75,
          position: "sticky",
          top: 0,
          zIndex: 1,
        }}
      >
        <Typography variant="caption" sx={{ fontWeight: 600, color: "#6B7280" }}>
          Mention Group Member
        </Typography>
      </Box>
      <List sx={{ p: 0 }}>
        {members.map((member, index) => (
          <ListItem
            key={member.id}
            button
            onClick={() => onSelect(member)}
            selected={selectedIndex === index}
            sx={{
              py: 1,
              px: 1.5,
              "&.Mui-selected": {
                backgroundColor: "rgba(124, 58, 237, 0.08)",
                "&:hover": {
                  backgroundColor: "rgba(124, 58, 237, 0.12)",
                },
              },
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.04)",
              },
            }}
          >
            <ListItemAvatar sx={{ minWidth: 40 }}>
              <Avatar
                src={member.avatar}
                sx={{ width: 32, height: 32, border: "1px solid #E5E7EB" }}
              >
                {member.name.charAt(0)}
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={
                <Typography variant="body2" sx={{ fontWeight: 600, color: "#374151" }}>
                  {member.name}
                </Typography>
              }
              secondary={
                member.userName ? (
                  <Typography variant="caption" sx={{ color: "#6B7280" }}>
                    @{member.userName}
                  </Typography>
                ) : null
              }
            />
          </ListItem>
        ))}
      </List>
    </Paper>
  );
});

export default MentionList;
